// extracted by mini-css-extract-plugin
export var accordionIcon = "style-mod--accordion-icon--cd41e";
export var accordionIconOpen = "style-mod--accordion-icon-open--96bc8";
export var bottomFooter = "style-mod--bottom-footer--6695b";
export var contactCol = "style-mod--contact-col--7035b";
export var desktopView = "style-mod--desktop-view--20b84";
export var divider = "style-mod--divider--51759";
export var flexRow = "style-mod--flex-row--6cf43";
export var foodboomLogo = "style-mod--foodboom-logo--96de2";
export var footer = "style-mod--footer--3d348";
export var footerContainer = "style-mod--footer-container--91cf4";
export var footerContent = "style-mod--footer-content--97938";
export var footerEmail = "style-mod--footer-email--aed04";
export var footerFlag = "style-mod--footer-flag--20f3f";
export var footerForm = "style-mod--footer-form--a3083";
export var footerList = "style-mod--footer-list--2e8fb";
export var footerNewsletter = "style-mod--footer-newsletter--57ced";
export var footerPhone = "style-mod--footer-phone--5209f";
export var footerTitle = "style-mod--footer-title--4da51";
export var formContainer = "style-mod--form-container--e6e28";
export var language = "style-mod--language--32f5a";
export var linksContainer = "style-mod--links-container--0acb0";
export var listTitle = "style-mod--list-title--13ee5";
export var listUl = "style-mod--list-ul--b51b2";
export var logo = "style-mod--logo--cebc1";
export var mobileView = "style-mod--mobile-view--57a18";
export var rightSide = "style-mod--right-side--2c3d4";
export var socialIcons = "style-mod--social-icons--f4559";